import { render, staticRenderFns } from "./ConsoleMain.vue?vue&type=template&id=0bf4862d&"
import script from "./ConsoleMain.vue?vue&type=script&lang=js&"
export * from "./ConsoleMain.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports